import { useState } from 'react';
import { api } from '../lib/api';
import NewItem, { type NewItemStart } from './NewItem';

/**
 * "Create a new item", for beside any item search. Opens the full New item form and, when it is saved, hands back the item as the
 * search would have found it, so the screen can use it right away as if it had been picked from the results.
 */
export default function NewItemButton({ onCreated, start, label = 'Create a new item', className = '' }: { onCreated: (item: any) => void; start?: NewItemStart; label?: string; className?: string }) {
  const [open, setOpen] = useState(false);
  const [err, setErr] = useState('');
  return (
    <>
      <button type="button" className={className} onClick={() => { setErr(''); setOpen(true); }}>{label}</button>
      {err && <span className="faint" style={{ color: 'var(--bad)' }}> {err}</span>}
      {open && (
        <NewItem start={start} onClose={() => setOpen(false)} onDone={async (r) => {
          setOpen(false);
          // the search finds an item by its barcode, so look it up the same way to get the row in the same shape
          const rows = await api<any[]>(`/api/items?q=${encodeURIComponent(r.code ?? r.name)}&limit=5`).catch(() => []);
          const row = rows.find((x) => x.id === r.itemId) ?? rows[0];
          if (row) onCreated(row); else setErr('The item was created, but could not be picked. Search for it.');
        }} />
      )}
    </>
  );
}
